import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SizingProgressDialogComponent } from './sizing-progress-dialog.component';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    SizingProgressDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    MatProgressBarModule,
    MatDialogModule
  ],
  exports: [
    SizingProgressDialogComponent
  ]
})
export class SizingProgressDialogModule { }

